export enum XlsListUploaderMessages {
  CLOSE_LABEL = 'Close',
  IMPORT_LABEL = 'Import List',
  FIRST_ROW_LABEL = 'First Row Contains Headers',
  FILE_PARSE_ERROR_MSG = "Your file has some issues. Let's resolve them and try again.",
}
